<template>
  <el-dialog
    :title="$t('app.cannotSubscribeTipTitle')"
    :visible.sync="canNotSubscribeCVisible"
    width="480px"
    custom-class="MyDialog"
    :close-on-click-modal="false"
  >
    <div class="canNotSubscribeCVisible-afn234">
      <div class="content">{{ $t('app.auto_344_1fc6be2a') }}</div>
      <img
        :src="imgSrc"
        alt=""
      />
      <el-button type="primary" @click="subscribeCConfirm">{{ $t('app.gotIt') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { checkDormantAccount } from "@/api/SquirrelSettlement";
export default {
  name: "canNotSubscribe",
  data() {
    return {
      canNotSubscribeCVisible: false,
      imgSrc: "",
    };
  },
  methods: {
    subscribeCConfirm() {
      this.canNotSubscribeCVisible = false;
    },
    validate(accountId) {
      return checkDormantAccount({
        accountId,
      }).then((res) => {
        if (res.code === 0 && res.data) {
          if (res.data.isDormantAccount) {
            this.canNotSubscribeCVisible = true;
            this.imgSrc = res.data.jumpUrl;
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      });
    },
  },
};
</script>

<style  lang="scss">
.canNotSubscribeCVisible-afn234 {
  text-align: center;
  img {
    width: 180px;
    height: 180px;
    margin: 24px auto;
    display: block;
  }
  .content {
    text-align: left;
  }
}
</style>